export const MIN_CUSTOM_STREET_WIDTH = 3 // meters
export const MAX_CUSTOM_STREET_WIDTH = 120 // meters
export const MIN_CUSTOM_STREET_WIDTH_IMPERIAL = 10 * 0.3048 // feet
export const MAX_CUSTOM_STREET_WIDTH_IMPERIAL = 400 * 0.3048 // feet

export const DEFAULT_CAPACITY_SOURCE = 'giz'
